/**
 * Identity provider env (Clerk preferred; legacy Cognito vars kept during migration).
 */
export const authEnv = {
  clerkPublishableKey: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY,
  region: process.env.REACT_APP_AUTH_REGION,
  userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
  cookieStorageDomain: process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN,
} as const;
